"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _attach = _interopRequireDefault(require("../attach"));

var _commonField = _interopRequireDefault(require("./common-field"));

var _pickers = require("@material-ui/pickers");

var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _displayValueTypography = _interopRequireDefault(require("./display-value-typography"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = function styles(theme) {
  return {
    root: {
      // We need to add a margin as the picker doesn't play well with the Material-UI label
      marginTop: theme.spacing(2)
    }
  };
};

var DateField = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(DateField, _React$PureComponent);

  var _super = _createSuper(DateField);

  function DateField() {
    var _this;

    (0, _classCallCheck2.default)(this, DateField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleDateChange", function (date) {
      _this.props.component.setValue(date);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleBlur", function () {
      _this.props.component.setTouched(true);
    });
    return _this;
  }

  (0, _createClass2.default)(DateField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          component = _this$props.component,
          classes = _this$props.classes,
          value = _this$props.value,
          includeTime = _this$props.includeTime,
          editable = _this$props.editable,
          useDisplayValue = _this$props.useDisplayValue,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate,
          fullWidth = _this$props.fullWidth,
          disabled = _this$props.disabled,
          accessEditable = _this$props.accessEditable,
          format = _this$props.format;
      var dis = accessEditable === false || disabled;
      var shrinkLabel = false;
      var Component = includeTime ? _pickers.DateTimePicker : _pickers.DatePicker;
      var fld = null;

      if (editable && !useDisplayValue) {
        // The picker doesn't play well with the label from Material-UI so we need to manually shrink
        // the label when there is a value.
        shrinkLabel = !!value;
        fld = /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
          utils: _dateFns.default
        }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(Component // Value cannot be undefined or else picker will default to today
        , {
          value: value ? value : null,
          onChange: this.handleDateChange,
          clearable: true,
          className: classes.root,
          minDate: minDate,
          maxDate: maxDate,
          onClose: this.handleBlur,
          fullWidth: fullWidth,
          disabled: dis,
          id: component.getUniqueId(),
          format: format
        })));
      } else {
        fld = /*#__PURE__*/_react.default.createElement(_displayValueTypography.default, null, component.getDisplayValue());
      }

      return /*#__PURE__*/_react.default.createElement(_commonField.default, {
        component: component,
        shrinkLabel: shrinkLabel
      }, fld);
    }
  }]);
  return DateField;
}(_react.default.PureComponent);

DateField = (0, _withStyles.default)(styles)(DateField);

var _default = (0, _attach.default)(['value', 'includeTime', 'editable', 'useDisplayValue', 'minDate', 'maxDate', 'fullWidth', 'disabled', 'format'])(DateField);

exports.default = _default;